import DC from "../../common/DataConnector";
import { i18n } from "../../lang/i18n";
import PayWithCardRedsys from "../CartAndPayment/PayWithCardRedsys";
import { reducerCartClear } from "../../store/Cart/CartReducer";
import { actAlertShow, actLoading, actLoadingEnd } from "../../store/Actions";
import { PaymentTypes } from "../../common/Enums";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

interface Props {
    onStepContinue: () => void
}
export default function DeliveryStepPayment(props: Props) {

    const dispatch = useAppDispatch()
    const cart = useAppSelector((state) => state.cart)
    async function generateOrderStart(paymentTypeId: number, paymentInfo: string = '') {
        actLoading(dispatch)
        let ps: any = [];
        let postData = {
            paymentType: { id: paymentTypeId },
            products: ps,
            totalProducts: cart.products.length,
            totalPrice: cart.totalPrice.toFixed(2),
            totalPriceVat: cart.totalVat.toFixed(2),
            paymentInfo: paymentInfo,
            address: { addressId: cart.addressId },
            transport: cart.transportPrice
        }

        const products = cart.products;
        for (let x = 0; x < products.length; x++) {
            postData.products.push({
                code: products[x].product.productCode,
                quantity: products[x].quantity,
                priceBase: products[x].priceBase,
                price: products[x].product.price,
                priceVat: products[x].product.priceVat,
                vatTypeId: products[x].product.vatType.id,
                title: products[x].product.title,
                discount: products[x].discount,
                preferences: products[x].preferences.filter(function (el: any) { return el.value; }),
                useRitmitos: products[x].useRitmitos
            });
        }

        let content = await DC.PostData('/customer/delivery-orders', postData);
        if (content.wasOk) {
            if (content.data.wasOk) {
                actLoadingEnd(dispatch)
                if (paymentTypeId !== PaymentTypes.GooglePay)
                    dispatch(reducerCartClear());
                return content.data;
            } else {
                actLoadingEnd(dispatch)
                actAlertShow(dispatch, 'warning', i18n.Errors.ErrorSavingData);
            }
        } else {
            actLoadingEnd(dispatch)
            actAlertShow(dispatch, 'warning', i18n.Errors.ErrorSavingData);
        }
    }

    async function onGetRedsysData(paymentTypeId: number) {
        return generateOrderStart(paymentTypeId);
    }

    return <div>
        <div className="box p-3">
            <div className="row">
                <div className="col-12 text-center"><h4>{i18n.TabCart.Subtitle}</h4></div>
                <br />
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <p>{i18n.CartDeliveryStep3.InfoLine1}</p>
                    <p>{i18n.CartDeliveryStep3.InfoLine2}</p>
                </div>
                <div className="col-12">
                </div>
            </div>
        </div>
        <div className="box text-center">
            <PayWithCardRedsys onGetRedsysData={onGetRedsysData} totalPrice={cart.totalPrice} title={i18n.TabCart.PayWithCard} style={{ maxWidth: '90%' }} />
        </div>
        <br />
    </div>
}